/**
 * Full-page loading state used by route guards while the session bootstrap
 * (`GET /api/auth/me`) is in flight. An honest, announced loading state — not
 * a blank screen (§10).
 */
export function LoadingScreen(): React.JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p role="status" className="text-slate-500">
        Loading…
      </p>
    </div>
  );
}
